import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Button } from "./ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";
import { navigationLinks } from "../data/mock";

const LOGO_WHITE_IMG = "/logo-white-transparent.png";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "glass border-b border-white/10 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-0"
          >
            <div className="flex flex-col leading-none">
              <span
                className="font-display text-[1.6rem] font-bold tracking-[0.04em]"
                style={{ color: scrolled ? "#1A1A1A" : "#FFFFFF" }}
              >
                LOBBEN
              </span>
              <span
                className="text-[0.65rem] font-medium tracking-[0.32em] uppercase mt-[1px]"
                style={{ color: "#C8A97E" }}
              >
                Event Co.
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className={`text-sm font-medium tracking-wide hover:text-gold ${
                  scrolled ? "text-charcoal/70" : "text-white/80"
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Button
              onClick={() => handleNavClick("#contact")}
              className="bg-gold hover:bg-gold-dark text-white font-medium px-6 h-10 rounded-full"
            >
              Book Now
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden">
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
              <SheetTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className={scrolled ? "text-charcoal" : "text-white"}
                >
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80 bg-warm-white">
                <SheetHeader>
                  <SheetTitle className="text-left">
                    <div className="flex flex-col leading-none">
                      <span className="font-display text-[1.4rem] font-bold tracking-[0.04em] text-charcoal">
                        LOBBEN
                      </span>
                      <span className="text-[0.6rem] font-medium tracking-[0.32em] uppercase text-gold mt-[1px]">
                        Event Co.
                      </span>
                    </div>
                  </SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col gap-4 mt-8">
                  {navigationLinks.map((link) => (
                    <button
                      key={link.href}
                      onClick={() => handleNavClick(link.href)}
                      className="text-left text-lg font-medium text-charcoal/80 hover:text-gold py-2 border-b border-border"
                    >
                      {link.label}
                    </button>
                  ))}
                  <Button
                    onClick={() => handleNavClick("#contact")}
                    className="bg-gold hover:bg-gold-dark text-white font-medium mt-4 rounded-full"
                  >
                    Book Now
                  </Button>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};
